export const translations = {
	'Action information is cleared due to data retention setting': {
		no: 'Handlingsinformasjon er slettet grunnet databevarings innstillinger',
	},
	'Are you sure you want to remove message?': {
		no: 'Vil du slette melding(ene)?',
	},
	'Message successfuly deleted': {
		no: 'Meldingen er slettet',
	},
	'Message sent.': {
		no: 'Meldingen er sendt',
	},
	'Send to cannot be empty': {
		no: 'Sendt til kan ikke være tomt',
	},
};
